import { z } from 'zod';
import { ReferenceSchema, UUIDSchema } from '../domain/models';
import { PaginationSchema } from '../domain/pagination';
import { PaginatedBundleSchema, PartialPeriodSchema } from '../domain/schema';

const PlanDefinitionStatusSchema = z.enum([
  'draft',
  'active',
  'retired',
  'unknown',
]);

export const PlanDefinitionSchema = z.object({
  id: UUIDSchema,
  questionnaires: z.array(ReferenceSchema),
  date: z.string(),
  description: z.string(),
  effectivePeriod: PartialPeriodSchema,
  status: PlanDefinitionStatusSchema,
  title: z.string(),
  version: z.string(),
});

export const PlanDefinitionGetResponseSchema = PlanDefinitionSchema;

export const PlanDefinitionGetAllResponseSchema = PaginatedBundleSchema.extend({
  planDefinitions: z.array(PlanDefinitionGetResponseSchema),
});

export const PlanDefinitionSearchSchema = PaginationSchema.extend({
  title: z.string().optional(),
  status: PlanDefinitionStatusSchema.optional(),
});

export type PlanDefinition = z.infer<typeof PlanDefinitionSchema>;
export type PlanDefinitionGetAllResponse = z.infer<
  typeof PlanDefinitionGetAllResponseSchema
>;
export type PlanDefinitionGetResponse = z.infer<
  typeof PlanDefinitionGetResponseSchema
>;
export type PlanDefinitionSearchParams = z.infer<
  typeof PlanDefinitionSearchSchema
>;
